import type { PackageMonitoringEntity } from './PackageMonitoringEntity'

export class PackageMonitoringResponseEntity {
  showCompletedPackageDurationInSecond?: number
  showCanceledPackageDurationInSecond?: number
  packages?: Array<PackageMonitoringEntity> | null
}
